import {
  Carservice,
  CarserviceEstimate,
  InfoSection,
  ProductExtra,
} from 'rest-client';

import {
  CarServiceOperationData,
  CarServiceOperationItem,
  CarServicePartData,
  CarServicePartItem,
} from '../models';
import {
  getServiceDescription,
  getServiceLongDescription,
} from './car-service-translations';

export function getPriceInfoSection(price: number, vatIncludedText: string): InfoSection {
  const priceInfo = new InfoSection();

  priceInfo.name = price.toString();
  priceInfo.body = vatIncludedText;

  priceInfo.type = 'price';

  return priceInfo;
}

export function getDetailPriceInfoSection(): InfoSection {
  const priceDetail = new InfoSection();

  priceDetail.type = 'priceDetail';

  return priceDetail;
}

export function getExtraInfoSection(extra: ProductExtra): InfoSection {
  const extraInfo = new InfoSection();

  extraInfo.body = extra.long_description
    ? extra.long_description
    : extra.description;

  return extraInfo;
}

export function getCarInfoSection(
  carService: Carservice,
  lang: string
): InfoSection {
  const carInfo = new InfoSection();

  carInfo.body = getServiceLongDescription(carService, lang)
    ? getServiceLongDescription(carService, lang)
    : getServiceDescription(carService, lang);

  return carInfo;
}

export function getCarInfoSectionFromEstimate(
  estimate: CarserviceEstimate
): InfoSection {
  const carInfo = new InfoSection();

  carInfo.body = estimate.description;

  return carInfo;
}

export function getOperationsInfoSection(): InfoSection {
  const operationsInfo = new InfoSection();

  operationsInfo.type = 'operations';

  return operationsInfo;
}

export function getPartsInfoSection(): InfoSection {
  const operationsInfo = new InfoSection();

  operationsInfo.type = 'parts';

  return operationsInfo;
}

export function buildViewCarServiceOperationsData(
  operations: CarServiceOperationItem[]
): CarServiceOperationData {
  const checkpoints = operations?.filter(
    (operation: CarServiceOperationItem) => operation.type === 'MAIN'
  );

  const more_checkpoints = operations?.filter(
    (operation: CarServiceOperationItem) =>
      operation.type === 'SUBDETAIL_INCLUDED' && !isNaN(+operation.code)
  );

  const subdetail_control = operations?.filter(
    (operation: CarServiceOperationItem) =>
      operation.type === 'SUBDETAIL_INCLUDED' && isNaN(+operation.code)
  );

  return {
    checkpoints: [...checkpoints, ...more_checkpoints],
    subdetail_control: subdetail_control,
  };
}

export function buildViewCarServicePartsData(
  parts: CarServicePartItem[]
): CarServicePartData {
  return {
    checkpoints: [...parts],
  };
}
